import { Suspense } from 'react'
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'
import { CacheProvider } from '@emotion/react'
import { getSharedProps } from '@/lib/sharedProps'
import ThemeProvider from '@/components/Mui/ThemeProvider'
import RootLayout from '@/pages/RootLayout'
import { type AppComponentType } from './Inertia'
import Page from './Page'

const AppComponent: AppComponentType = ({ App, emotionCache, props }) => {
  return (
    <>
      <InitColorSchemeScript attribute='data' />
      <CacheProvider value={emotionCache}>
        <ThemeProvider>
          <App {...props}>{renderApp}</App>
        </ThemeProvider>
      </CacheProvider>
    </>
  )
}

const renderApp = ({ Component: { page, layouts }, key, props }: any) => {
  return (
    <Suspense>
      <RootLayout {...getSharedProps(props as any)}>
        <Page page={page} layouts={layouts} inertiaKey={key} props={props} />
      </RootLayout>
    </Suspense>
  )
}

export default AppComponent
